export default __webpack_public_path__ + "static/media/logo2.8e9ad86e.png";